// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Thumbnails Api v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import { httpClient as globalAxios } from '../../../http/http';
import { AxiosPromise, AxiosInstance } from 'axios';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ApiArrayResponseThumbnailBatchResponse
 */
export interface ApiArrayResponseThumbnailBatchResponse {
    /**
     * 
     * @type {Array<ThumbnailBatchResponse>}
     * @memberof ApiArrayResponseThumbnailBatchResponse
     */
    data?: Array<ThumbnailBatchResponse>;
}
/**
 * 
 * @export
 * @interface ApiArrayResponseThumbnailResponse
 */
export interface ApiArrayResponseThumbnailResponse {
    /**
     * 
     * @type {Array<ThumbnailResponse>}
     * @memberof ApiArrayResponseThumbnailResponse
     */
    data?: Array<ThumbnailResponse>;
}
/**
 * 
 * @export
 * @interface ApiArrayResponseUniverseThumbnailsResponse
 */
export interface ApiArrayResponseUniverseThumbnailsResponse {
    /**
     * 
     * @type {Array<UniverseThumbnailsResponse>}
     * @memberof ApiArrayResponseUniverseThumbnailsResponse
     */
    data?: Array<UniverseThumbnailsResponse>;
}
/**
 * 
 * @export
 * @interface ApiErrorModel
 */
export interface ApiErrorModel {
    /**
     * 
     * @type {number}
     * @memberof ApiErrorModel
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorModel
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiErrorModel
     */
    field?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiErrorModel
     */
    fieldData?: object;
}
/**
 * 
 * @export
 * @interface ImageParameters
 */
export interface ImageParameters {
    /**
     * 
     * @type {number}
     * @memberof ImageParameters
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof ImageParameters
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageParameters
     */
    format?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageParameters
     */
    thumbnailFormatID?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageParameters
     */
    fileExtension?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageParameters
     */
    mimeType?: string;
}
/**
 * 
 * @export
 * @interface ThumbnailBatchRequest
 */
export interface ThumbnailBatchRequest {
    /**
     * The request id. (Generated client side, used to represent the items in the request)
     * @type {string}
     * @memberof ThumbnailBatchRequest
     */
    requestId?: string;
    /**
     * The thumbnail target id
     * @type {number}
     * @memberof ThumbnailBatchRequest
     */
    targetId?: number;
    /**
     * The type of the thumbnails
     * @type {string}
     * @memberof ThumbnailBatchRequest
     */
    type?: ThumbnailBatchRequestTypeEnum;
    /**
     * The thumbnail size
     * @type {string}
     * @memberof ThumbnailBatchRequest
     */
    size?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ThumbnailBatchRequestTypeEnum {
    GroupIcon = 'GroupIcon',
    Avatar = 'Avatar',
    AvatarHeadShot = 'AvatarHeadShot',
    GameIcon = 'GameIcon',
    BadgeIcon = 'BadgeIcon',
    GameThumbnail = 'GameThumbnail',
    GamePass = 'GamePass',
    Asset = 'Asset',
    BundleThumbnail = 'BundleThumbnail',
    Outfit = 'Outfit'
}

/**
 * 
 * @export
 * @interface ThumbnailBatchResponse
 */
export interface ThumbnailBatchResponse {
    /**
     * 
     * @type {string}
     * @memberof ThumbnailBatchResponse
     */
    requestId?: string;
    /**
     * 
     * @type {number}
     * @memberof ThumbnailBatchResponse
     */
    errorCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailBatchResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof ThumbnailBatchResponse
     */
    targetId?: number;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailBatchResponse
     */
    state?: ThumbnailBatchResponseStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailBatchResponse
     */
    imageUrl?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ThumbnailBatchResponseStateEnum {
    Error = 'Error',
    Completed = 'Completed',
    InReview = 'InReview',
    Pending = 'Pending',
    Blocked = 'Blocked'
}

/**
 * 
 * @export
 * @interface ThumbnailResponse
 */
export interface ThumbnailResponse {
    /**
     * 
     * @type {number}
     * @memberof ThumbnailResponse
     */
    targetId?: number;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailResponse
     */
    state?: ThumbnailResponseStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailResponse
     */
    imageUrl?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ThumbnailResponseStateEnum {
    Error = 'Error',
    Completed = 'Completed',
    InReview = 'InReview',
    Pending = 'Pending',
    Blocked = 'Blocked'
}

/**
 * A response model for thumbnails which belong to a specific universe ID
 * @export
 * @interface UniverseThumbnailsResponse
 */
export interface UniverseThumbnailsResponse {
    /**
     * Integer universe ID
     * @type {number}
     * @memberof UniverseThumbnailsResponse
     */
    universeId?: number;
    /**
     * 
     * @type {ApiErrorModel}
     * @memberof UniverseThumbnailsResponse
     */
    error?: ApiErrorModel;
    /**
     * An array of ThumbnailResponse objects
     * @type {Array<ThumbnailResponse>}
     * @memberof UniverseThumbnailsResponse
     */
    thumbnails?: Array<ThumbnailResponse>;
}

/**
 * AssetsApi - axios parameter creator
 * @export
 */
export const AssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Thumbnails assets.
         * @param {Array<number>} assetIds The asset ids.
         * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting thumbnail to return (default &#x3D; PlaceHolder).
         * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssetsGet(assetIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '150x150' | '420x420', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'assetIds' is not null or undefined
            if (assetIds === null || assetIds === undefined) {
                throw new RequiredError('assetIds','Required parameter assetIds was null or undefined when calling v1AssetsGet.');
            }
            const localVarPath = `/v1/assets`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assetIds) {
                localVarQueryParameter['assetIds'] = assetIds.join(COLLECTION_FORMATS.csv);
            }

            if (returnPolicy !== undefined) {
                localVarQueryParameter['returnPolicy'] = returnPolicy;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetsApi - functional programming interface
 * @export
 */
export const AssetsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Thumbnails assets.
         * @param {Array<number>} assetIds The asset ids.
         * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting thumbnail to return (default &#x3D; PlaceHolder).
         * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssetsGet(assetIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '150x150' | '420x420', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailResponse> {
            const localVarAxiosArgs = AssetsApiAxiosParamCreator(configuration).v1AssetsGet(assetIds, returnPolicy, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AssetsApi - factory interface
 * @export
 */
export const AssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Thumbnails assets.
         * @param {Array<number>} assetIds The asset ids.
         * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting thumbnail to return (default &#x3D; PlaceHolder).
         * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssetsGet(assetIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '150x150' | '420x420', format?: number, options?: any) {
            return AssetsApiFp(configuration).v1AssetsGet(assetIds, returnPolicy, size, format, options)(axios, basePath);
        },
    };
};

/**
 * AssetsApi - interface
 * @export
 * @interface AssetsApi
 */
export interface AssetsApiInterface {
    /**
     * 
     * @summary Thumbnails assets.
     * @param {Array<number>} assetIds The asset ids.
     * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting thumbnail to return (default &#x3D; PlaceHolder).
     * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    v1AssetsGet(assetIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '150x150' | '420x420', format?: number, options?: any): AxiosPromise<ApiArrayResponseThumbnailResponse>;

}

/**
 * AssetsApi - object-oriented interface
 * @export
 * @class AssetsApi
 * @extends {BaseAPI}
 */
export class AssetsApi extends BaseAPI implements AssetsApiInterface {
    /**
     * 
     * @summary Thumbnails assets.
     * @param {Array<number>} assetIds The asset ids.
     * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting thumbnail to return (default &#x3D; PlaceHolder).
     * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public v1AssetsGet(assetIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '150x150' | '420x420', format?: number, options?: any) {
        return AssetsApiFp(this.configuration).v1AssetsGet(assetIds, returnPolicy, size, format, options)(this.axios, this.basePath);
    }

}


/**
 * AvatarApi - axios parameter creator
 * @export
 */
export const AvatarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Avatar Full body shots for the given CSV of userIds
         * @param {Array<number>} userIds CSV for the userIds to get avatar full body shots
         * @param {'100x100' | '352x352' | '720x720'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UsersAvatarGet(userIds: Array<number>, size?: '100x100' | '352x352' | '720x720', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'userIds' is not null or undefined
            if (userIds === null || userIds === undefined) {
                throw new RequiredError('userIds','Required parameter userIds was null or undefined when calling v1UsersAvatarGet.');
            }
            const localVarPath = `/v1/users/avatar`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userIds) {
                localVarQueryParameter['userIds'] = userIds.join(COLLECTION_FORMATS.csv);
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Avatar Headshots for the given CSV of userIds
         * @param {Array<number>} userIds CSV for the userIds to get avatar headshots
         * @param {'48x48' | '60x60' | '150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UsersAvatarHeadshotGet(userIds: Array<number>, size?: '48x48' | '60x60' | '150x150', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'userIds' is not null or undefined
            if (userIds === null || userIds === undefined) {
                throw new RequiredError('userIds','Required parameter userIds was null or undefined when calling v1UsersAvatarHeadshotGet.');
            }
            const localVarPath = `/v1/users/avatar-headshot`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userIds) {
                localVarQueryParameter['userIds'] = userIds.join(COLLECTION_FORMATS.csv);
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AvatarApi - functional programming interface
 * @export
 */
export const AvatarApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Avatar Full body shots for the given CSV of userIds
         * @param {Array<number>} userIds CSV for the userIds to get avatar full body shots
         * @param {'100x100' | '352x352' | '720x720'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UsersAvatarGet(userIds: Array<number>, size?: '100x100' | '352x352' | '720x720', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailResponse> {
            const localVarAxiosArgs = AvatarApiAxiosParamCreator(configuration).v1UsersAvatarGet(userIds, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get Avatar Headshots for the given CSV of userIds
         * @param {Array<number>} userIds CSV for the userIds to get avatar headshots
         * @param {'48x48' | '60x60' | '150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UsersAvatarHeadshotGet(userIds: Array<number>, size?: '48x48' | '60x60' | '150x150', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailResponse> {
            const localVarAxiosArgs = AvatarApiAxiosParamCreator(configuration).v1UsersAvatarHeadshotGet(userIds, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AvatarApi - factory interface
 * @export
 */
export const AvatarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get Avatar Full body shots for the given CSV of userIds
         * @param {Array<number>} userIds CSV for the userIds to get avatar full body shots
         * @param {'100x100' | '352x352' | '720x720'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UsersAvatarGet(userIds: Array<number>, size?: '100x100' | '352x352' | '720x720', format?: number, options?: any) {
            return AvatarApiFp(configuration).v1UsersAvatarGet(userIds, size, format, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get Avatar Headshots for the given CSV of userIds
         * @param {Array<number>} userIds CSV for the userIds to get avatar headshots
         * @param {'48x48' | '60x60' | '150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UsersAvatarHeadshotGet(userIds: Array<number>, size?: '48x48' | '60x60' | '150x150', format?: number, options?: any) {
            return AvatarApiFp(configuration).v1UsersAvatarHeadshotGet(userIds, size, format, options)(axios, basePath);
        },
    };
};

/**
 * AvatarApi - interface
 * @export
 * @interface AvatarApi
 */
export interface AvatarApiInterface {
    /**
     * 
     * @summary Get Avatar Full body shots for the given CSV of userIds
     * @param {Array<number>} userIds CSV for the userIds to get avatar full body shots
     * @param {'100x100' | '352x352' | '720x720'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvatarApiInterface
     */
    v1UsersAvatarGet(userIds: Array<number>, size?: '100x100' | '352x352' | '720x720', format?: number, options?: any): AxiosPromise<ApiArrayResponseThumbnailResponse>;

    /**
     * 
     * @summary Get Avatar Headshots for the given CSV of userIds
     * @param {Array<number>} userIds CSV for the userIds to get avatar headshots
     * @param {'48x48' | '60x60' | '150x150'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvatarApiInterface
     */
    v1UsersAvatarHeadshotGet(userIds: Array<number>, size?: '48x48' | '60x60' | '150x150', format?: number, options?: any): AxiosPromise<ApiArrayResponseThumbnailResponse>;

}

/**
 * AvatarApi - object-oriented interface
 * @export
 * @class AvatarApi
 * @extends {BaseAPI}
 */
export class AvatarApi extends BaseAPI implements AvatarApiInterface {
    /**
     * 
     * @summary Get Avatar Full body shots for the given CSV of userIds
     * @param {Array<number>} userIds CSV for the userIds to get avatar full body shots
     * @param {'100x100' | '352x352' | '720x720'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvatarApi
     */
    public v1UsersAvatarGet(userIds: Array<number>, size?: '100x100' | '352x352' | '720x720', format?: number, options?: any) {
        return AvatarApiFp(this.configuration).v1UsersAvatarGet(userIds, size, format, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get Avatar Headshots for the given CSV of userIds
     * @param {Array<number>} userIds CSV for the userIds to get avatar headshots
     * @param {'48x48' | '60x60' | '150x150'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvatarApi
     */
    public v1UsersAvatarHeadshotGet(userIds: Array<number>, size?: '48x48' | '60x60' | '150x150', format?: number, options?: any) {
        return AvatarApiFp(this.configuration).v1UsersAvatarHeadshotGet(userIds, size, format, options)(this.axios, this.basePath);
    }

}


/**
 * BadgesApi - axios parameter creator
 * @export
 */
export const BadgesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Thumbnails badge icons.
         * @param {Array<number>} badgeIds The badge ids.
         * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BadgesIconsGet(badgeIds: Array<number>, size?: '150x150', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'badgeIds' is not null or undefined
            if (badgeIds === null || badgeIds === undefined) {
                throw new RequiredError('badgeIds','Required parameter badgeIds was null or undefined when calling v1BadgesIconsGet.');
            }
            const localVarPath = `/v1/badges/icons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (badgeIds) {
                localVarQueryParameter['badgeIds'] = badgeIds.join(COLLECTION_FORMATS.csv);
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BadgesApi - functional programming interface
 * @export
 */
export const BadgesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Thumbnails badge icons.
         * @param {Array<number>} badgeIds The badge ids.
         * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BadgesIconsGet(badgeIds: Array<number>, size?: '150x150', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailResponse> {
            const localVarAxiosArgs = BadgesApiAxiosParamCreator(configuration).v1BadgesIconsGet(badgeIds, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BadgesApi - factory interface
 * @export
 */
export const BadgesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Thumbnails badge icons.
         * @param {Array<number>} badgeIds The badge ids.
         * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BadgesIconsGet(badgeIds: Array<number>, size?: '150x150', format?: number, options?: any) {
            return BadgesApiFp(configuration).v1BadgesIconsGet(badgeIds, size, format, options)(axios, basePath);
        },
    };
};

/**
 * BadgesApi - interface
 * @export
 * @interface BadgesApi
 */
export interface BadgesApiInterface {
    /**
     * 
     * @summary Thumbnails badge icons.
     * @param {Array<number>} badgeIds The badge ids.
     * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApiInterface
     */
    v1BadgesIconsGet(badgeIds: Array<number>, size?: '150x150', format?: number, options?: any): AxiosPromise<ApiArrayResponseThumbnailResponse>;

}

/**
 * BadgesApi - object-oriented interface
 * @export
 * @class BadgesApi
 * @extends {BaseAPI}
 */
export class BadgesApi extends BaseAPI implements BadgesApiInterface {
    /**
     * 
     * @summary Thumbnails badge icons.
     * @param {Array<number>} badgeIds The badge ids.
     * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApi
     */
    public v1BadgesIconsGet(badgeIds: Array<number>, size?: '150x150', format?: number, options?: any) {
        return BadgesApiFp(this.configuration).v1BadgesIconsGet(badgeIds, size, format, options)(this.axios, this.basePath);
    }

}


/**
 * BatchApi - axios parameter creator
 * @export
 */
export const BatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<ThumbnailBatchRequest>} requests 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BatchPost(requests: Array<ThumbnailBatchRequest>, options: any = {}): RequestArgs {
            // verify required parameter 'requests' is not null or undefined
            if (requests === null || requests === undefined) {
                throw new RequiredError('requests','Required parameter requests was null or undefined when calling v1BatchPost.');
            }
            const localVarPath = `/v1/batch`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"Array&lt;ThumbnailBatchRequest&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requests !== undefined ? requests : {}) : (requests || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BatchApi - functional programming interface
 * @export
 */
export const BatchApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<ThumbnailBatchRequest>} requests 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BatchPost(requests: Array<ThumbnailBatchRequest>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailBatchResponse> {
            const localVarAxiosArgs = BatchApiAxiosParamCreator(configuration).v1BatchPost(requests, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BatchApi - factory interface
 * @export
 */
export const BatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {Array<ThumbnailBatchRequest>} requests 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BatchPost(requests: Array<ThumbnailBatchRequest>, options?: any) {
            return BatchApiFp(configuration).v1BatchPost(requests, options)(axios, basePath);
        },
    };
};

/**
 * BatchApi - interface
 * @export
 * @interface BatchApi
 */
export interface BatchApiInterface {
    /**
     * 
     * @param {Array<ThumbnailBatchRequest>} requests 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApiInterface
     */
    v1BatchPost(requests: Array<ThumbnailBatchRequest>, options?: any): AxiosPromise<ApiArrayResponseThumbnailBatchResponse>;

}

/**
 * BatchApi - object-oriented interface
 * @export
 * @class BatchApi
 * @extends {BaseAPI}
 */
export class BatchApi extends BaseAPI implements BatchApiInterface {
    /**
     * 
     * @param {Array<ThumbnailBatchRequest>} requests 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    public v1BatchPost(requests: Array<ThumbnailBatchRequest>, options?: any) {
        return BatchApiFp(this.configuration).v1BatchPost(requests, options)(this.axios, this.basePath);
    }

}


/**
 * BundlesApi - axios parameter creator
 * @export
 */
export const BundlesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get bundle thumbnails for the given CSV of bundle ids
         * @param {Array<number>} bundleIds CSV for the bundle ids to get bundle thumbnails
         * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BundlesThumbnailsGet(bundleIds: Array<number>, size?: '150x150' | '420x420', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'bundleIds' is not null or undefined
            if (bundleIds === null || bundleIds === undefined) {
                throw new RequiredError('bundleIds','Required parameter bundleIds was null or undefined when calling v1BundlesThumbnailsGet.');
            }
            const localVarPath = `/v1/bundles/thumbnails`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bundleIds) {
                localVarQueryParameter['bundleIds'] = bundleIds.join(COLLECTION_FORMATS.csv);
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BundlesApi - functional programming interface
 * @export
 */
export const BundlesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get bundle thumbnails for the given CSV of bundle ids
         * @param {Array<number>} bundleIds CSV for the bundle ids to get bundle thumbnails
         * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BundlesThumbnailsGet(bundleIds: Array<number>, size?: '150x150' | '420x420', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailResponse> {
            const localVarAxiosArgs = BundlesApiAxiosParamCreator(configuration).v1BundlesThumbnailsGet(bundleIds, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BundlesApi - factory interface
 * @export
 */
export const BundlesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get bundle thumbnails for the given CSV of bundle ids
         * @param {Array<number>} bundleIds CSV for the bundle ids to get bundle thumbnails
         * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1BundlesThumbnailsGet(bundleIds: Array<number>, size?: '150x150' | '420x420', format?: number, options?: any) {
            return BundlesApiFp(configuration).v1BundlesThumbnailsGet(bundleIds, size, format, options)(axios, basePath);
        },
    };
};

/**
 * BundlesApi - interface
 * @export
 * @interface BundlesApi
 */
export interface BundlesApiInterface {
    /**
     * 
     * @summary Get bundle thumbnails for the given CSV of bundle ids
     * @param {Array<number>} bundleIds CSV for the bundle ids to get bundle thumbnails
     * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundlesApiInterface
     */
    v1BundlesThumbnailsGet(bundleIds: Array<number>, size?: '150x150' | '420x420', format?: number, options?: any): AxiosPromise<ApiArrayResponseThumbnailResponse>;

}

/**
 * BundlesApi - object-oriented interface
 * @export
 * @class BundlesApi
 * @extends {BaseAPI}
 */
export class BundlesApi extends BaseAPI implements BundlesApiInterface {
    /**
     * 
     * @summary Get bundle thumbnails for the given CSV of bundle ids
     * @param {Array<number>} bundleIds CSV for the bundle ids to get bundle thumbnails
     * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundlesApi
     */
    public v1BundlesThumbnailsGet(bundleIds: Array<number>, size?: '150x150' | '420x420', format?: number, options?: any) {
        return BundlesApiFp(this.configuration).v1BundlesThumbnailsGet(bundleIds, size, format, options)(this.axios, this.basePath);
    }

}


/**
 * GamePassesApi - axios parameter creator
 * @export
 */
export const GamePassesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Thumbnails game pass icons.
         * @param {Array<number>} gamePassIds The game pass ids.
         * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamePassesGet(gamePassIds: Array<number>, size?: '150x150', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'gamePassIds' is not null or undefined
            if (gamePassIds === null || gamePassIds === undefined) {
                throw new RequiredError('gamePassIds','Required parameter gamePassIds was null or undefined when calling v1GamePassesGet.');
            }
            const localVarPath = `/v1/game-passes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamePassIds) {
                localVarQueryParameter['gamePassIds'] = gamePassIds.join(COLLECTION_FORMATS.csv);
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GamePassesApi - functional programming interface
 * @export
 */
export const GamePassesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Thumbnails game pass icons.
         * @param {Array<number>} gamePassIds The game pass ids.
         * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamePassesGet(gamePassIds: Array<number>, size?: '150x150', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailResponse> {
            const localVarAxiosArgs = GamePassesApiAxiosParamCreator(configuration).v1GamePassesGet(gamePassIds, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GamePassesApi - factory interface
 * @export
 */
export const GamePassesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Thumbnails game pass icons.
         * @param {Array<number>} gamePassIds The game pass ids.
         * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamePassesGet(gamePassIds: Array<number>, size?: '150x150', format?: number, options?: any) {
            return GamePassesApiFp(configuration).v1GamePassesGet(gamePassIds, size, format, options)(axios, basePath);
        },
    };
};

/**
 * GamePassesApi - interface
 * @export
 * @interface GamePassesApi
 */
export interface GamePassesApiInterface {
    /**
     * 
     * @summary Thumbnails game pass icons.
     * @param {Array<number>} gamePassIds The game pass ids.
     * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamePassesApiInterface
     */
    v1GamePassesGet(gamePassIds: Array<number>, size?: '150x150', format?: number, options?: any): AxiosPromise<ApiArrayResponseThumbnailResponse>;

}

/**
 * GamePassesApi - object-oriented interface
 * @export
 * @class GamePassesApi
 * @extends {BaseAPI}
 */
export class GamePassesApi extends BaseAPI implements GamePassesApiInterface {
    /**
     * 
     * @summary Thumbnails game pass icons.
     * @param {Array<number>} gamePassIds The game pass ids.
     * @param {'150x150'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamePassesApi
     */
    public v1GamePassesGet(gamePassIds: Array<number>, size?: '150x150', format?: number, options?: any) {
        return GamePassesApiFp(this.configuration).v1GamePassesGet(gamePassIds, size, format, options)(this.axios, this.basePath);
    }

}


/**
 * GamesApi - axios parameter creator
 * @export
 */
export const GamesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetches game icon URLs for a list of universes\' root places. Ids that do not correspond to a valid universe will be filtered out.
         * @param {Array<number>} universeIds The universe ids.
         * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting game icon to return (default &#x3D; PlaceHolder).
         * @param {'50x50' | '150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamesIconsGet(universeIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '50x50' | '150x150', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'universeIds' is not null or undefined
            if (universeIds === null || universeIds === undefined) {
                throw new RequiredError('universeIds','Required parameter universeIds was null or undefined when calling v1GamesIconsGet.');
            }
            const localVarPath = `/v1/games/icons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (universeIds) {
                localVarQueryParameter['universeIds'] = universeIds.join(COLLECTION_FORMATS.csv);
            }

            if (returnPolicy !== undefined) {
                localVarQueryParameter['returnPolicy'] = returnPolicy;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch game thumbnail URLs for a list of universe IDs.
         * @param {Array<number>} universeIds comma-delimited list of universe IDs
         * @param {number} [countPerUniverse] max number of thumbnails to return per universe
         * @param {boolean} [defaults] true if defaults (if any) should be returned if no media exists
         * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamesMultigetThumbnailsGet(universeIds: Array<number>, countPerUniverse?: number, defaults?: boolean, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'universeIds' is not null or undefined
            if (universeIds === null || universeIds === undefined) {
                throw new RequiredError('universeIds','Required parameter universeIds was null or undefined when calling v1GamesMultigetThumbnailsGet.');
            }
            const localVarPath = `/v1/games/multiget/thumbnails`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (universeIds) {
                localVarQueryParameter['universeIds'] = universeIds.join(COLLECTION_FORMATS.csv);
            }

            if (countPerUniverse !== undefined) {
                localVarQueryParameter['countPerUniverse'] = countPerUniverse;
            }

            if (defaults !== undefined) {
                localVarQueryParameter['defaults'] = defaults;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches game thumbnail URLs for a list of universes\' thumbnail ids. Ids that do not correspond to a valid thumbnail will be filtered out.
         * @param {number} universeId 
         * @param {Array<number>} thumbnailIds 
         * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamesUniverseIdThumbnailsGet(universeId: number, thumbnailIds: Array<number>, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'universeId' is not null or undefined
            if (universeId === null || universeId === undefined) {
                throw new RequiredError('universeId','Required parameter universeId was null or undefined when calling v1GamesUniverseIdThumbnailsGet.');
            }
            // verify required parameter 'thumbnailIds' is not null or undefined
            if (thumbnailIds === null || thumbnailIds === undefined) {
                throw new RequiredError('thumbnailIds','Required parameter thumbnailIds was null or undefined when calling v1GamesUniverseIdThumbnailsGet.');
            }
            const localVarPath = `/v1/games/{universeId}/thumbnails`
                .replace(`{${"universeId"}}`, encodeURIComponent(String(universeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (thumbnailIds) {
                localVarQueryParameter['thumbnailIds'] = thumbnailIds.join(COLLECTION_FORMATS.csv);
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GamesApi - functional programming interface
 * @export
 */
export const GamesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetches game icon URLs for a list of universes\' root places. Ids that do not correspond to a valid universe will be filtered out.
         * @param {Array<number>} universeIds The universe ids.
         * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting game icon to return (default &#x3D; PlaceHolder).
         * @param {'50x50' | '150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamesIconsGet(universeIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '50x50' | '150x150', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailResponse> {
            const localVarAxiosArgs = GamesApiAxiosParamCreator(configuration).v1GamesIconsGet(universeIds, returnPolicy, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Fetch game thumbnail URLs for a list of universe IDs.
         * @param {Array<number>} universeIds comma-delimited list of universe IDs
         * @param {number} [countPerUniverse] max number of thumbnails to return per universe
         * @param {boolean} [defaults] true if defaults (if any) should be returned if no media exists
         * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamesMultigetThumbnailsGet(universeIds: Array<number>, countPerUniverse?: number, defaults?: boolean, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseUniverseThumbnailsResponse> {
            const localVarAxiosArgs = GamesApiAxiosParamCreator(configuration).v1GamesMultigetThumbnailsGet(universeIds, countPerUniverse, defaults, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Fetches game thumbnail URLs for a list of universes\' thumbnail ids. Ids that do not correspond to a valid thumbnail will be filtered out.
         * @param {number} universeId 
         * @param {Array<number>} thumbnailIds 
         * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamesUniverseIdThumbnailsGet(universeId: number, thumbnailIds: Array<number>, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailResponse> {
            const localVarAxiosArgs = GamesApiAxiosParamCreator(configuration).v1GamesUniverseIdThumbnailsGet(universeId, thumbnailIds, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GamesApi - factory interface
 * @export
 */
export const GamesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Fetches game icon URLs for a list of universes\' root places. Ids that do not correspond to a valid universe will be filtered out.
         * @param {Array<number>} universeIds The universe ids.
         * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting game icon to return (default &#x3D; PlaceHolder).
         * @param {'50x50' | '150x150'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamesIconsGet(universeIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '50x50' | '150x150', format?: number, options?: any) {
            return GamesApiFp(configuration).v1GamesIconsGet(universeIds, returnPolicy, size, format, options)(axios, basePath);
        },
        /**
         * 
         * @summary Fetch game thumbnail URLs for a list of universe IDs.
         * @param {Array<number>} universeIds comma-delimited list of universe IDs
         * @param {number} [countPerUniverse] max number of thumbnails to return per universe
         * @param {boolean} [defaults] true if defaults (if any) should be returned if no media exists
         * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamesMultigetThumbnailsGet(universeIds: Array<number>, countPerUniverse?: number, defaults?: boolean, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options?: any) {
            return GamesApiFp(configuration).v1GamesMultigetThumbnailsGet(universeIds, countPerUniverse, defaults, size, format, options)(axios, basePath);
        },
        /**
         * 
         * @summary Fetches game thumbnail URLs for a list of universes\' thumbnail ids. Ids that do not correspond to a valid thumbnail will be filtered out.
         * @param {number} universeId 
         * @param {Array<number>} thumbnailIds 
         * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GamesUniverseIdThumbnailsGet(universeId: number, thumbnailIds: Array<number>, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options?: any) {
            return GamesApiFp(configuration).v1GamesUniverseIdThumbnailsGet(universeId, thumbnailIds, size, format, options)(axios, basePath);
        },
    };
};

/**
 * GamesApi - interface
 * @export
 * @interface GamesApi
 */
export interface GamesApiInterface {
    /**
     * 
     * @summary Fetches game icon URLs for a list of universes\' root places. Ids that do not correspond to a valid universe will be filtered out.
     * @param {Array<number>} universeIds The universe ids.
     * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting game icon to return (default &#x3D; PlaceHolder).
     * @param {'50x50' | '150x150'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApiInterface
     */
    v1GamesIconsGet(universeIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '50x50' | '150x150', format?: number, options?: any): AxiosPromise<ApiArrayResponseThumbnailResponse>;

    /**
     * 
     * @summary Fetch game thumbnail URLs for a list of universe IDs.
     * @param {Array<number>} universeIds comma-delimited list of universe IDs
     * @param {number} [countPerUniverse] max number of thumbnails to return per universe
     * @param {boolean} [defaults] true if defaults (if any) should be returned if no media exists
     * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApiInterface
     */
    v1GamesMultigetThumbnailsGet(universeIds: Array<number>, countPerUniverse?: number, defaults?: boolean, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options?: any): AxiosPromise<ApiArrayResponseUniverseThumbnailsResponse>;

    /**
     * 
     * @summary Fetches game thumbnail URLs for a list of universes\' thumbnail ids. Ids that do not correspond to a valid thumbnail will be filtered out.
     * @param {number} universeId 
     * @param {Array<number>} thumbnailIds 
     * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApiInterface
     */
    v1GamesUniverseIdThumbnailsGet(universeId: number, thumbnailIds: Array<number>, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options?: any): AxiosPromise<ApiArrayResponseThumbnailResponse>;

}

/**
 * GamesApi - object-oriented interface
 * @export
 * @class GamesApi
 * @extends {BaseAPI}
 */
export class GamesApi extends BaseAPI implements GamesApiInterface {
    /**
     * 
     * @summary Fetches game icon URLs for a list of universes\' root places. Ids that do not correspond to a valid universe will be filtered out.
     * @param {Array<number>} universeIds The universe ids.
     * @param {'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated'} [returnPolicy] Optional policy to use in selecting game icon to return (default &#x3D; PlaceHolder).
     * @param {'50x50' | '150x150'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    public v1GamesIconsGet(universeIds: Array<number>, returnPolicy?: 'PlaceHolder' | 'AutoGenerated' | 'ForceAutoGenerated', size?: '50x50' | '150x150', format?: number, options?: any) {
        return GamesApiFp(this.configuration).v1GamesIconsGet(universeIds, returnPolicy, size, format, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Fetch game thumbnail URLs for a list of universe IDs.
     * @param {Array<number>} universeIds comma-delimited list of universe IDs
     * @param {number} [countPerUniverse] max number of thumbnails to return per universe
     * @param {boolean} [defaults] true if defaults (if any) should be returned if no media exists
     * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    public v1GamesMultigetThumbnailsGet(universeIds: Array<number>, countPerUniverse?: number, defaults?: boolean, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options?: any) {
        return GamesApiFp(this.configuration).v1GamesMultigetThumbnailsGet(universeIds, countPerUniverse, defaults, size, format, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Fetches game thumbnail URLs for a list of universes\' thumbnail ids. Ids that do not correspond to a valid thumbnail will be filtered out.
     * @param {number} universeId 
     * @param {Array<number>} thumbnailIds 
     * @param {'768x432' | '576x324' | '480x270' | '384x216' | '256x144'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesApi
     */
    public v1GamesUniverseIdThumbnailsGet(universeId: number, thumbnailIds: Array<number>, size?: '768x432' | '576x324' | '480x270' | '384x216' | '256x144', format?: number, options?: any) {
        return GamesApiFp(this.configuration).v1GamesUniverseIdThumbnailsGet(universeId, thumbnailIds, size, format, options)(this.axios, this.basePath);
    }

}


/**
 * GroupEmblemApi - axios parameter creator
 * @export
 */
export const GroupEmblemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetches thumbnail URLs for a list of groups. Ids that do not correspond to groups will be filtered out.
         * @param {Array<number>} groupIds 
         * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GroupsIconsGet(groupIds: Array<number>, size?: '150x150' | '420x420', format?: number, options: any = {}): RequestArgs {
            // verify required parameter 'groupIds' is not null or undefined
            if (groupIds === null || groupIds === undefined) {
                throw new RequiredError('groupIds','Required parameter groupIds was null or undefined when calling v1GroupsIconsGet.');
            }
            const localVarPath = `/v1/groups/icons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupIds) {
                localVarQueryParameter['groupIds'] = groupIds.join(COLLECTION_FORMATS.csv);
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupEmblemApi - functional programming interface
 * @export
 */
export const GroupEmblemApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetches thumbnail URLs for a list of groups. Ids that do not correspond to groups will be filtered out.
         * @param {Array<number>} groupIds 
         * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GroupsIconsGet(groupIds: Array<number>, size?: '150x150' | '420x420', format?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiArrayResponseThumbnailResponse> {
            const localVarAxiosArgs = GroupEmblemApiAxiosParamCreator(configuration).v1GroupsIconsGet(groupIds, size, format, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GroupEmblemApi - factory interface
 * @export
 */
export const GroupEmblemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Fetches thumbnail URLs for a list of groups. Ids that do not correspond to groups will be filtered out.
         * @param {Array<number>} groupIds 
         * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
         * @param {number} [format] The thumbnail format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GroupsIconsGet(groupIds: Array<number>, size?: '150x150' | '420x420', format?: number, options?: any) {
            return GroupEmblemApiFp(configuration).v1GroupsIconsGet(groupIds, size, format, options)(axios, basePath);
        },
    };
};

/**
 * GroupEmblemApi - interface
 * @export
 * @interface GroupEmblemApi
 */
export interface GroupEmblemApiInterface {
    /**
     * 
     * @summary Fetches thumbnail URLs for a list of groups. Ids that do not correspond to groups will be filtered out.
     * @param {Array<number>} groupIds 
     * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupEmblemApiInterface
     */
    v1GroupsIconsGet(groupIds: Array<number>, size?: '150x150' | '420x420', format?: number, options?: any): AxiosPromise<ApiArrayResponseThumbnailResponse>;

}

/**
 * GroupEmblemApi - object-oriented interface
 * @export
 * @class GroupEmblemApi
 * @extends {BaseAPI}
 */
export class GroupEmblemApi extends BaseAPI implements GroupEmblemApiInterface {
    /**
     * 
     * @summary Fetches thumbnail URLs for a list of groups. Ids that do not correspond to groups will be filtered out.
     * @param {Array<number>} groupIds 
     * @param {'150x150' | '420x420'} [size] The thumbnail size, formatted widthxheight
     * @param {number} [format] The thumbnail format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupEmblemApi
     */
    public v1GroupsIconsGet(groupIds: Array<number>, size?: '150x150' | '420x420', format?: number, options?: any) {
        return GroupEmblemApiFp(this.configuration).v1GroupsIconsGet(groupIds, size, format, options)(this.axios, this.basePath);
    }

}


